import type { SlaConfig } from "@shared/schema";

const PRIORITY_LABELS: Record<string, string> = {
  urgent: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
};

function formatSlaHours(hours: number | null | undefined): string {
  if (typeof hours === "number" && hours > 0) {
    return `${hours} hr${hours === 1 ? "" : "s"}`;
  }
  return "no SLA set";
}

export function priorityWithSla(
  slaConfig: SlaConfig | null | undefined,
  priority: string,
): string {
  const label = PRIORITY_LABELS[priority] ?? priority;
  const hours = slaConfig?.[priority as keyof SlaConfig];
  return `${label} (${formatSlaHours(hours)})`;
}
